import script from "./DraggingIntervention.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggingIntervention.vue?vue&type=script&setup=true&lang=js"

import "./DraggingIntervention.vue?vue&type=style&index=0&id=1eb88c74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb88c74"]])

export default __exports__